import { useTranslation } from "react-i18next";

import ActionButtonLayout from "./ActionButtonLayout";

function MomSysMergeLotButtonLayout ( props ) {

    const { t } = useTranslation();

    return <ActionButtonLayout {...props}>{t("buttonName.mergeLot")}</ActionButtonLayout>;

}

export default MomSysMergeLotButtonLayout;

